import { registerApiAxiosInstance } from '@pba/react-network';
import type { AxiosError, AxiosResponse } from 'axios';

export { googleReCaptchaSiteKey } from './api-keys';

import { queryClient } from 'query/query-client';
import apiClient from './api-client';
// TODO: check if this file should be import like this - 82948
import { logout } from './hooks';
import { defaultHeadersInterceptor } from './interceptors/default-headers-interceptor';
// TODO: check if this file should be import like this - 82948
import { defaultRailsInterceptor } from './interceptors/rails/default-rails-interceptor';

export type ApiClientResponse<T> = AxiosResponse<T>;

export type ApiClientResponseError<T> = AxiosError<T>;

export type DefaultResponseErrorDataObject = {
  error: string;
  'invalid-params'?: Array<{ name: string; reason: string }>;
  message: string;
};

export type ResponseErrorDataObject = DefaultResponseErrorDataObject | ValidationResponseErrorDataObject;

export type ValidationResponseErrorDataObject = {
  errors: Record<string, string[]>;
  'invalid-params'?: Array<{ name: string; reason: string }>;
};

export const isValidationResponseErrorDataObject = (data: unknown): data is ValidationResponseErrorDataObject =>
  Boolean(data) &&
  typeof data === 'object' &&
  data !== null &&
  'errors' in data &&
  typeof data.errors === 'object' &&
  data.errors !== null &&
  !Array.isArray(data.errors);

export const isDefaultResponseErrorDataObject = (data: unknown): data is DefaultResponseErrorDataObject =>
  Boolean(data) &&
  typeof data === 'object' &&
  data !== null &&
  'error' in data &&
  typeof data.error === 'string' &&
  'message' in data &&
  typeof data.message === 'string';

apiClient.interceptors.request.use((config) => defaultHeadersInterceptor(config));
apiClient.interceptors.request.use(async (config) => defaultRailsInterceptor(config));

apiClient.interceptors.response.use(
  (response) => normalizeSuccessResponse(response),
  async (error) => {
    await normalizeErrorResponse(error);
  },
);

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
async function normalizeErrorResponse(error: any) {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
  checkFrontendVersionHeader(error.response?.headers);

  if (
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
    ['invalid_grant', 'invalid_token', 'user_banned'].includes(error.response?.data?.error) ||
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
    error.response?.status === 401
  ) {
    // TODO change one day to new logout
    await logout();
  }

  throw error;
}

function normalizeSuccessResponse<T>(response: AxiosResponse<T>): ApiClientResponse<T> {
  checkFrontendVersionHeader(response.headers);

  return response;
}

registerApiAxiosInstance({ instance: apiClient });

const FRONTEND_VERSION_STORAGE_KEY = 'version';

function checkFrontendVersionHeader(headers?: Record<string, unknown>) {
  const apiVersion = headers?.['x-version-fe'];

  if (typeof apiVersion !== 'string') {
    return;
  }

  const localVersion = localStorage.getItem(FRONTEND_VERSION_STORAGE_KEY);

  if (apiVersion !== localVersion) {
    localStorage.setItem(FRONTEND_VERSION_STORAGE_KEY, apiVersion);

    if (localVersion) {
      queryClient.clear();
    }
  }
}
